import {
  RouteConfig
} from 'vue-router'

const newContainer = () => import('@/layouts/Default.vue');
import EditAnalysisAlgorithm from "./../views/analysisAlgorithm/editAnalysisAlgorithm.vue"
import SearchAnalysisAlgorithm from "./../views/analysisAlgorithm/searchAnalysisAlgorithm.vue"
import editAzmoonExecute from "./../views/azmoon_execute/editAzmoonExecute.vue"
import searchAzmoonExecute from "./../views/azmoon_execute/searchAzmoonExecute.vue"

const routerParent = () => import('@/components/base/routerParrent.vue');
const structureQuestion = () => import('./../views/question/structureQuestion.vue');
const searchQuestion = () => import('./../views/question/searchQuestion.vue');
const editQuestion = () => import('./../views/question/editQuestion.vue');
const searchExamPack = () => import("./../views/examPack/searchExamPack.vue")
const editExamPack = () => import("./../views/examPack/editExamPack.vue")
const searchTitle = () => import("./../views/question_title/searchQuestionTitle.vue")
const searchOption = () => import("./../views/question_option/searchQuestionOption.vue")
const executePage = () => import("./../views/execute/executePage.vue")

export const azmoonRoutes: RouteConfig[] = [
  {
    path: '/azmoon',
    name: 'dynamic_home',
    meta: {
      label: "خانه",
      requiresAuth: true
    },
    component: newContainer,
    children: [
      {
        path: 'question',
        name: 'question',
        meta: {
          label: "مخزن سوال",
          requiresAuth: true
        },
        redirect: '/azmoon/question/search',
        component: routerParent,
        children: [
          {
            path: 'search',
            name: 'searchQuestion',
            component: searchQuestion,
            meta: {
              label: "لیست سوال‌ها",
              requiresAuth: true
            },
          },
          {
            path: 'edit/:id',
            name: 'edit_questions',
            component: editQuestion,
            meta: {
              label: "ویرایش سوال",
              requiresAuth: true
            },
          },
          {
            path: 'structureQuestion',
            name: 'structureQuestion',
            component: structureQuestion,
            meta: {
              label: "طراحی سوال",
              requiresAuth: true
            },
          },
          {
            path: 'structureQuestion/edit/:id',
            name: 'edit_structureQuestion',
            component: structureQuestion,
            meta: {
              label: "ویرایش سوال",
              requiresAuth: true
            },
          }
        ]
      },
      {
        path: 'question_title',
        name: 'title',
        meta: {
          label: "مخزن آزمون",
          requiresAuth: true
        },
        redirect: '/azmoon/question_title/search',
        component: routerParent,
        children: [
          {
            path: 'search',
            name: 'search_question_title',
            component: searchTitle,
            meta: {
              label: "عنوان‌های سوال",
              requiresAuth: true
            },
          },
          {
            path: 'edit/:id',
            name: 'edit_question_title',
            meta: {
              label: "ویرایش عنوان‌های سوال",
              requiresAuth: true
            },
          }
        ]
      },
      {
        path: 'question_option',
        name: 'option',
        meta: {
          label: "مخزن گزینه‌ها",
          requiresAuth: true
        },
        redirect: '/azmoon/question_option/search',
        component: routerParent,
        children: [
          {
            path: 'search',
            name: 'search_question_option',
            component: searchOption,
            meta: {
              label: " گزینه‌های جواب",
              requiresAuth: true
            },
          },
          {
            path: 'edit/:id',
            name: 'edit_question_option',
            meta: {
              label: "ویرایش سوال",
              requiresAuth: true
            },
          }
        ]
      },
      {
        path: 'exam_pack',
        name: 'exam_pack',
        meta: {
          label: "مخزن پرسشنامه",
          requiresAuth: true
        },
        redirect: '/azmoon/exam_pack/search',
        component: routerParent,
        children: [
          {
            path: 'search',
            name: 'search_exam_pack',
            component: searchExamPack,
            meta: {
              label: "لیست پرسشنامه‌ها",
              requiresAuth: true
            },
          },
          {
            path: 'edit/:id',
            name: 'edit_exam_pack',
            component: editExamPack,
            meta: {
              label: "ویرایش پرسشنامه",
              requiresAuth: true
            },
          }
        ],
      },
      {
        path: 'azmoon_execute',
        name: 'azmoon_execute',
        meta: {
          label: " آزمون",
          requiresAuth: true
        },
        redirect: '/azmoon/azmoon_execute/search',
        component: routerParent,
        children: [
          {
            path: 'search',
            name: 'search_azmoon_execute',
            component: searchAzmoonExecute,
            meta: {
              label: "اجرای آزمون",
              requiresAuth: true
            },
          },
          {
            path: 'edit/:id',
            name: 'edit_azmoon_execute',
            component: editAzmoonExecute,
            meta: {
              label: "ویرایش برگزاری آزمون",
              requiresAuth: true
            },
          },
        ],
      },
    ]
  },
  {
    path: '/execute',
    name: 'execute',
    meta: {
      label: "execute",
      requiresAuth: true
    },
    component: routerParent,
    redirect: '/execute/search',
    children: [
      {
        path: ':id/exam_pack/:exam_pack_id',
        name: 'azmoon_execute_exam_pack',
        component: executePage,
        meta: {
          label: "اجرای آزمون",
          requiresAuth: true
        },
      },
    ],
  },
  {
    path: '/analysis-algorithm',
    name: 'analysis_algorithm',
    meta: {
      label: "تعریف روش محاسبه",
      requiresAuth: true
    },
    component: newContainer,
    redirect: '/analysis-algorithm/search',
    children: [
      {
        path: 'search',
        name: 'search_analysis_algorithm',
        component: SearchAnalysisAlgorithm,
        meta: {
          label: "لیست الگوریتم",
          requiresAuth: true
        },
      },
      {
        path: 'edit/:id',
        name: 'edit_analysis_algorithm',
        component: EditAnalysisAlgorithm,
        meta: {
          label: "ویرایش الگوریتم",
          requiresAuth: true
        },
      },
    ],
  },
];
